import { render, staticRenderFns } from "./NerisIncident.vue?vue&type=template&id=6c6b2fad&"
import script from "./NerisIncident.vue?vue&type=script&lang=js&"
export * from "./NerisIncident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports